import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { getSEODataForRoute } from "@/data/seoData";

/**
 * Fallback SEO component that sets meta tags from the central seoData map.
 * Placed at the router level, it provides baseline metadata for every route.
 * Individual page components using <SEO> or <TechnicalSEO> will override these
 * values via react-helmet-async's priority system (last rendered wins).
 */
export function RouteMetaDefaults() {
  const { pathname } = useLocation();
  const data = getSEODataForRoute(pathname);

  const CANONICAL_ORIGIN = "https://www.londonsecondaryglazing.co.uk";
  const normalizedPath =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.replace(/\/+$/, "")
      : pathname;
  const canonical = `${CANONICAL_ORIGIN}${normalizedPath}`;

  const siteTitle = "London Secondary Glazing";
  const fullTitle = data
    ? data.title.toLowerCase().includes("london")
      ? data.title
      : `${data.title} | ${siteTitle}`
    : null;

  return (
    <Helmet prioritizeSeoTags>
      {/* Global canonical fallback for every route — page-level <SEO> overrides via Helmet priority */}
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
      {fullTitle && <title>{fullTitle}</title>}
      {data && <meta name="description" content={data.description} />}
      {fullTitle && <meta property="og:title" content={fullTitle} />}
      {data && <meta property="og:description" content={data.description} />}
      {fullTitle && <meta name="twitter:title" content={fullTitle} />}
      {data && <meta name="twitter:description" content={data.description} />}
    </Helmet>
  );
}
